import { formatDate } from '@/lib/utils'

export type FormationEvent = {
  id: string
  event_type: string
  particulars: Record<string, unknown>
  actor: string | null
  created_at: string
}

const EVENT_LABELS: Record<string, string> = {
  name_cleared: 'Name cleared',
  state_filing_submitted: 'State filing recorded',
  state_filing_accepted: 'Certificate recorded',
  tax_registration_completed: 'EIN issued',
  registered_agent_updated: 'Registered agent updated',
  business_address_recorded: 'Business address added',
  business_address_updated: 'Business address updated',
  formation_completed: 'Formation marked complete'
}

// Every staff action on this formation, audited: who did what, and when.
export function ActivitySection({ events }: { events: FormationEvent[] }) {
  if (events.length === 0) return null

  return (
    <section className="border rounded-lg">
      <div className="px-4 py-3 border-b">
        <h2 className="text-sm font-medium text-foreground">Activity</h2>
      </div>
      <ol className="divide-y">
        {events.map((event) => (
          <li key={event.id} className="flex items-center justify-between gap-3 px-4 py-3 text-sm">
            <span className="text-foreground">{EVENT_LABELS[event.event_type] || event.event_type}</span>
            <span className="text-xs text-muted-foreground shrink-0">
              {event.actor ? `${event.actor} · ` : ''}
              {formatDate(event.created_at)}
            </span>
          </li>
        ))}
      </ol>
    </section>
  )
}
